import policy from '../policy/en'
import terms from '../terms/en'

export default {
  app: {
    title: 'Buy robuxi Roblox on RbxPier.me at a low price',
    description:
      'Buy Robux for Roblox cheap on RbxPier.me. Purchase Robux, transfers, and gift cards for Roblox quickly, ' +
      'cheaply, and safely. A reliable site with real reviews. Don’t miss out on the Robux Haven promotions!',
    h1: 'Buy Robux',
    titlePostfix: {
      methods: 'Select method',
      transfer: 'Transfer method',
      logpass: 'LogPass method',
      premium: 'Premium LOG+PASS method',
      payment: 'Refill'
    },
    purchase: {
      title: 'Buy Robux for Roblox Cheap on RbxPier.me',
      description:
        'Buy Robux for Roblox cheap on RbxPier.me. Purchase Robux, transfers, and gift cards for Roblox quickly, ' +
        'cheaply, and safely. A reliable site with real reviews. Don’t miss out on the Robux Haven promotions!'
    },
    // Meta for the product pages and the purchase methods. The copy here is a
    // placeholder: RBXGD-1086 delivered Russian copy only, English still ours.
    methods: {
      title: 'Ways to Buy Roblox Robux on RbxPier.me',
      description:
        'All the ways to buy Robux on RbxPier.me: transfer, gift cards, Super Pass and Robux packs. Compare the rates and pick the method that suits you.'
    },
    transfer: {
      title: 'Buy Roblox Robux via Transfer on RbxPier.me',
      description:
        'Buy Roblox Robux with the Transfer method on RbxPier.me — fast delivery to your account, a fair rate and a safe deal. Trusted since 2018, with real customer reviews.',
      h1: 'Buying Robux with the Transfer method'
    },
    giftcards: {
      title: 'Roblox Gift Cards — Buy a Gift Card on RbxPier.me',
      description:
        'Buy a Roblox Gift Card on RbxPier.me at a low price. Instant code delivery, secure payment methods and 24/7 support.',
      h1: 'Buying Roblox gift cards'
    },
    superpass: {
      title: 'Buy a Roblox Super Pass Cheap on RbxPier.me',
      description:
        'Buy Robux through the Super Pass on RbxPier.me — a fair rate and delivery without waiting. Pick a game, enter your nickname and get Robux on your Roblox account.',
      h1: 'Buying a Roblox Super Pass'
    },
    packs: {
      title: 'Roblox Robux Packs — Buy a Robux Pack on RbxPier.me',
      description:
        'Buy Robux packs on RbxPier.me — ready-made Robux bundles for your Roblox account at a fixed price. Quick checkout and secure payment.',
      h1: 'Buying Robux packs'
    },
    premium: {
      title: 'Buy Roblox Premium on RbxPier.me',
      description:
        'Buy a Roblox Premium subscription on RbxPier.me — activation on your account, a fair price and secure payment. A reliable service since 2018.'
    },
    logpass: {
      title: 'Buy Robux with the LogPass Method on RbxPier.me',
      description:
        'Buy Roblox Robux with the LogPass method on RbxPier.me — delivery to your account by login and password, a fair rate and a guaranteed safe deal.'
    },
    fastpass: {
      title: 'Buy Robux with the FastPass Method on RbxPier.me',
      description:
        'Buy Roblox Robux with the FastPass method on RbxPier.me — fast delivery to your account without long waiting. A fair rate and secure payment.'
    },
    termsofuse: {
      title: 'User Agreement of RbxPier.me',
      description:
        'Familiarize yourself with the terms of use of the RbxPier.me site: the rights and obligations of users and the operator, the procedure for the agreement to take effect.'
    },
    privacy: {
      title: 'Privacy Policy of RbxPier.me',
      description:
        'Review the privacy policy of RbxPier.me: the terms of processing personal data, the use of cookies, and users rights.'
    },
    contacts: {
      title: 'Documents and Contacts on RbxPier.me',
      description:
        'Review the documents of the RbxPier.me site and get complete contact information: address, email, and social media. Reliability and transparency for every user.'
    },
    payment: {
      title: 'Account Top-Up for Purchasing Robux on RbxPier.me',
      description:
        'Top up your balance to quickly and conveniently buy Robux for your Roblox account. Instant crediting and secure payment methods: MIR, SBP, VISA, MASTERCARD.'
    },
    history: {
      title: 'Purchase History on RbxPier.me',
      description: 'Track the history and the status of your Robux orders on RbxPier.me.'
    },
    notFound: {
      title: 'Page Not Found (404) | RbxPier.me',
      description: 'Unfortunately, the page you requested was not found. Try going back to the homepage.'
    },
    serviceUnavailable: {
      title: 'Service Temporarily Unavailable (503) | RbxPier.me',
      description: 'Maintenance is currently underway. Please try again later.'
    }
  },
  navigation: {
    title: 'NAVIGATION',
    home: 'HOME',
    logoText: 'Working since 2018',
    buyRobux: 'BUY ROBUX',
    packs: 'ROBUX PACKS',
    lk: 'PERSONAL ACCOUNT',
    vk: 'VK Group',
    discord: 'Discord',
    telegram: 'Telegram',
    instagram: 'Instagram',
    tiktok: 'Tik tok',
    about: 'ABOUT',
    dropdown: {
      history: 'History',
      changePassword: 'Change password',
      refill: 'Top up',
      logout: 'Exit',
      copyId: 'Copy ID',
      copyIdBase: 'Copy ID'
    }
  },
  general: {
    warning: 'Attention!',
    error: 'Error',
    temporarilyUnavailable: 'Temporarily unavailable',
    gotIt: 'Understood',
    confirm: 'CONFIRMATION',
    or: 'or',
    link: 'link',
    transfer: 'transfer',
    gifts: 'gift cards',
    superPass: 'super-pass',
    packs: 'robux packs',
    policy: 'PRIVACY POLICY',
    terms: 'USER AGREEMENT',

    errors: {
      internal: 'Internal error, please try again later',
      server: 'Server error'
    }
  },
  actions: {
    continue: 'Continue',
    submit: 'CONFIRM',
    buyRobux: 'BUY ROBUX',
    openDiscord: 'GO TO DISCORD',
    openInstruction: 'GO TO THE INSTRUCTIONS',
    createAccount: 'Create an account',
    login: 'LOG IN TO ACCOUNT',
    loginVK: 'Log in using VK',
    signin: 'Log in',
    enterPassword: 'Enter it',
    skip: 'Skip',
    buy: 'Purchase',
    buyOrder: 'Buy',
    tryAgain: 'Repeat again',

    create: 'Create',
    ready: 'Ready',
    edit: 'Edit',
    apply: 'Apply',
    remove: 'Remove',
    participate: 'Participate',
    try: 'Try',
    watch: 'Watch',
    subscribe: 'Subscribe',
    open: 'Open',
    promocode: {
      default: 'Promo code not applied',
      success: 'Promo code applied',
      error: 'Failed to apply promo code',
      minError: 'Minimum purchase amount is {min} R$',
      maxError: 'Maximum purchase amount is {max} R$',
      isNoPromo: 'Promo code does not exist!',
      promoExpired: 'The code has expired!',
      promoMaxUsage: 'The code has expired!',
      notAuth: 'Authorization required!',
      reuse: 'Code has been used before!',
      min: 'Min',
      max: 'Max'
    }
  },
  payment: {
    refill: 'Replenishment of the balance',
    total: 'Total',
    toPay: 'To be paid',
    pay: 'PAY',
    makeOrder: 'Pay for the order',
    otherPaymentMethods: 'Other payment methods',
    enterSum: 'Enter the deposit amount',
    commission: 'Commission:',
    notEnough: "You don't have enough funds to pay!",
    problems: 'In case of problems, write to our {support}',
    support: 'support service',
    selectPaymentMethod: 'CHOOSE A PAYMENT METHOD',
    replenishmentAmount: 'The amount of the deposit:',
    email: 'E-mail:',
    subTitle: 'CHECK THE DATA:',
    errors: {
      server: 'Replenishment failed. Try again later',
      empty: 'Select a payment method for payment'
    }
  },
  order: {
    status: 'ORDER STATUS',
    wait: 'PLEASE WAIT FOR the order to be completed',
    waitTime: 'REMAINS',
    code: 'The code must consist of 6 digits',
    mailCode: 'Enter the code from the mail',
    makeNewOrder: 'Make another order',
    table: {
      nickname: 'GAME NICKNAME',
      count: 'QUANTITY R$',
      total: 'TOTAL, RUB'
    },
    descriptions: {
      wait: 'Wait for the order to be completed',
      notEnoughFunds: "Error. The site doesn't have enough funds!",
      systemError: 'System error!',
      checkVip: 'Check the settings VIP ROBLOX!',
      connectionError: 'Communication error with ROBLOX!',
      success: 'The order has been successfully completed!',
      checkGamepass: 'The gift card code has been issued',
      gift: 'Gift card code issued',
      passInGame: 'Click to perform \n' + 'the necessary action!',
      passSuccess: 'Order completed',
      passWaiting: 'Operation in progress',
      passCancel: 'Operation canceled',
      error: 'Funds have been returned to the balance'
    },
    cancelReason: {
      noJoin: 'You did not join the server',
      noPlay: 'You have never played the game before',
      alreadyBought: 'You already purchased this pass',
      gameError: 'Failed to deliver the pass',
      serverError: 'The problem with the Roblox server',
      other: 'Order canceled'
    }
  },
  auth: {
    authorization: 'Authorization',
    registration: 'Registration',
    recovery: 'RECOVERY',
    change: 'CHANGE PASSWORD',

    inputs: {
      email: 'Enter E-mail',
      login: 'Enter login',
      loginOrEmail: 'Enter username or E-mail',
      currentPassword: 'Current password',
      newPassword: 'New password',
      repeatNewPassword: 'Repeat the new password',
      password: 'Enter password',
      passwordSubmit: 'Confirm password'
    },

    errors: {
      email: 'Invalid E-mail!',
      incorrectPassword: 'The password is incorrect!',
      empty: 'The field is empty',
      nicknameIsTooSmall: 'You must specify a name consisting of at least 4 characters',
      inactiveEmail: 'Email is invalid',
      passwordIsTooSmall: 'Your password must be between 6 and 18 characters long',
      passwordNotMatch: "Passwords don't match",
      oneUppercase: 'Your password must have at least one capital letter',
      userExist: 'A user with such data already exists',
      checkEmail: 'Make sure your email/username is correct',
      checkPassword: 'Make sure your password is correct',
      changePasswordIncorrect: 'The password must be from 6 to 18 characters and consist of the letters “A-z”!',
      social: 'Sign-in failed. Please try again or use another method'
    },

    welcome: {
      title: 'WELCOME',
      content: 'REGISTER ON OUR WEBSITE AND START BUYING ROBUX SECURELY, QUICKLY AND SAFELY'
    },

    forget: 'Forgot your password?',
    remember: 'Did you remember the password?',
    agreement: 'I agree with {policy} and {agreement}',
    privacyPolicy: 'privacy policy',
    userAgreement: 'user agreement',
    haveAccount: 'Do you already have an account?',
    codeSent: 'A password recovery code has been sent to {email}!',
    enterCode: 'Enter the 6-digit code:',
    requestCode: 'Request again',

    changePasswordSuccess: {
      title: 'Great!',
      content: 'You have successfully changed your password! Be sure to remember...'
    }
  },
  slider: {
    // slide1: {
    //   title: 'BLOGGERS TRUST US',
    //   content: 'OVER THE SIX YEARS OF THE SITE\'S EXISTENCE, THERE HAVE BEEN HUNDREDS OF THOUSANDS OF ORDERS. BUY SAFELY IN A TRUSTED STORE'
    // },
    // slide2: {
    //   title: 'WE HAVE THE LOWEST PRICES!',
    //   content: 'BUY ROBUX AND BECOME THE BEST AMONG YOUR FRIENDS. MAKE YOUR DREAM COME TRUE!'
    // },
    // slide3: {
    //   title: 'STILL IN DOUBT?',
    //   content: 'THOUSANDS OF SATISFIED CUSTOMERS WITH REAL REVIEWS ON OUR SOCIAL NETWORKS!'
    // },
    slide1: {
      title: 'Meet Gift Cards!',
      content:
        'Buy a gift card and get <span class="active-text sm">Robux instantly!</span> You also have a chance to receive unique items with purchases of 800 robux or more!'
    },
    slide2: {
      title: 'FAST DELIVERY!',
      content: 'We credit Robux in pending <span class="active-text sm">within 1 minute</span> after payment!'
    },
    slide3: {
      title: 'STILL DOUBTING?',
      content:
        'THOUSANDS OF SATISFIED CUSTOMERS <span class="active-text sm">WITH REAL REVIEWS</span> IN OUR SOCIAL NETWORKS!'
    },
    slide4: {
      title: 'DRAWING ON <span class="active-text"> 30 000 ROBUX!</span>',
      content: 'Are you still not participating? Then someone else will win'
    },
    slide5: {
      title: 'Meet the Super Pass Method!',
      content:
        '<span class="active-text sm">Instant delivery</span> of passes for Roblox games at an even more favorable rate!'
    }
  },
  faq: {
    title: 'КУПИТЬ РОБУКСЫ ЛЕГКО!',
    content: 'FOLLOW THREE SIMPLE STEPS',
    items: {
      item1: {
        index: '01',
        title: 'MAKE AN ORDER',
        content: 'ENTER THE NUMBER OF ROBUX AND YOUR NICKNAME ROBLOX'
      },
      item2: {
        index: '02',
        title: 'Pay',
        content: 'Pay for the order in any convenient way'
      },
      item3: {
        index: '03',
        title: 'GET ROBUX',
        content: 'Get robux to your gaming account within 5 days!'
      }
    }
  },
  help: {
    title: 'Having trouble buying robux?',
    text1: 'Our support will definitely help you with them on the server in discord or in personal Instagram messages!',
    text2: 'You can also use the instructions for'
  },
  footer: {
    privacy: 'PRIVACY POLICY',
    terms: 'USER AGREEMENT',
    contacts: 'CONTACT INFORMATION'
  },
  partnership: {
    title: 'Partnership',
    info: 'We offer profitable partnership for bloggers'
  },
  methods: {
    title: 'WHICH PURCHASE METHOD DO YOU WANT TO USE?',
    hintError: {
      title: 'Error!',
      content: 'You already have Roblox Premium!'
    },
    method: 'Method',
    fast: 'Fast',
    pass: 'Pass',
    robux: 'Robux',
    premium: 'Premium',
    transfer: 'Transfer',
    logpass: 'log+pass',
    available: 'Available',
    notAvailable: 'Out of stock'
  },
  cookie: {
    whatIsCookie: 'What is a COOKIE?',
    checkInstruction: 'READ THE COOKIE INSTRUCTIONS',
    enter: 'Enter a Cookie',
    description: {
      part1:
        'Cookies themselves are not dangerous — they are ordinary text files. They cannot run processes on the computer or interact with the operating system at all. But they may try to intercept or steal them in order to track your previous online activities or log into your accounts without authorization.',
      part2:
        'Usually, the information that is recorded in cookies is encrypted before sending, and the cookies themselves are transmitted via HTTPS protocol. This helps protect user data, but the site developer is responsible for implementing encryption and secure sending. Visitors can only hope that everything is set up correctly. For their part, the user can only prohibit the browser from using cookies or from time to time to clean them themselves.'
    }
  },
  // transfer: {
  //   robuxDelivery: 'Robux will be credited within 5 days (120 hours)',
  //   available: 'Available:',
  //   robuxCount: 'Number of robux',
  //   minumum: 'Minimum from {min} R$',
  //   nickname: 'Game nickname',
  //   notFound: 'Nothing found',
  //   checkPlaces: 'PLEASE CHECK THAT YOU HAVE CREATED AT LEAST 1 PLACE THAT IS PUBLIC',
  //   vipPrice: 'Set the VIP server price to {price}',
  //   changePrice: 'Change the price',
  //   orderSuccess: 'You can track the receipt of Robux to your account {here}',
  //   orderError: 'Funds have been returned to the ROBUXPIER account balance. Try again :)',
  //   here: 'here',
  //   gamepass: {
  //     checkData: 'Check the correctness of the data in Gamepass!',
  //     creating: 'CREATING',
  //     settingUp: 'SETUP',
  //     createGamepass: 'Create a Game-pass',
  //     checkInstruction: 'View the instructions and set the price <span>{price} R$</span>',
  //     checkInstructionNew: 'Take a close look at the instructions',
  //     serverError: 'Something went wrong. Try again.',
  //     setPrice: 'Set the price'
  //   },
  //
  //   errors: {
  //     insufficientBalance: 'Insufficient funds on the balance sheet',
  //     notAuthorized: 'You are not logged in',
  //     serverError: 'Error on the server',
  //     robuxNotAvailable: 'The number of robucks is not available for purchase',
  //
  //     priceNotNumber: 'The price must be a number',
  //     robuxMinimum: "You can't order less than {robux} robucks",
  //     robuxMaximun: 'The maximum purchase amount is temporarily limited to 5k R$',
  //     halfBalance: "You can't order more than half of the balance: {balance} robucks",
  //     emptyBalance: 'The site has run out of robux, waiting for replenishment',
  //     robuxMustDivide: 'R$ must be divided by {orders}. Try <span class="min">{closestMin}R$</span> or <span class="max">{closestMax}R$</span>'
  //   },
  //   selectYourPlace: 'Choose your own'
  // },
  transfer: {
    title: 'Purchase by transfer method',
    titleSmall: 'Transfer',
    subTitle: 'Delivery time for Robux to the account is 5 days',
    subTitleIncreaseTime: 'After that, the deadline for robux receipt to the account is 5 days.',
    charactersTitle: 'Enter your nickname',
    charactersSubTitle: 'Select your character from the list',
    placeTitle: 'Choose your place',
    paymentSubTitle: 'Please double-check all information before payment',
    robuxDelivery: 'Robux will be credited within 5 days (120 hours)',
    available: 'Available:',
    robuxCount: 'Number of Robux',
    minumum: 'Minimum of {min} R$',
    nickname: 'In-game nickname',
    notFound: 'Nothing found',
    checkPlaces: 'PLEASE CHECK THAT YOU HAVE AT LEAST 1 PLACE CREATED THAT IS PUBLIC',
    vipPrice: 'Set the price of the VIP server to {price}',
    changePrice: 'Change price',
    orderSuccess: 'You can track the delivery of Robux to your account {here}',
    orderError: 'Funds have been returned to the ROBUXPIER account balance. Please try again :)',
    here: 'here',
    promoSwitch: 'I have a promo code',
    promoInfo: 'Where to get a promo code?',
    gamepass: {
      checkData: 'Check the correctness of the data in Gamepass!',
      creating: 'CREATING',
      settingUp: 'SETTING UP',
      createGamepass: 'Create a Game-pass',
      checkInstruction: 'Check the instructions and set the price to <span class="text-color--blue">{price} R$</span>',
      checkInstructionNew: 'Carefully review the instructions',
      serverError: 'Check that the gamepad has been created',
      setPrice: 'Set the price',
      success: 'Successful!',
      successHint:
        'This Gamepass is already set up! If you want to change the amount, then please start the purchase again!',
      regionalPriceHint: 'Uncheck "Enable regional pricing" and try again!'
    },
    errors: {
      insufficientBalance: 'Insufficient funds in the balance',
      notAuthorized: 'You are not authorized',
      serverError: 'Server error',
      robuxNotAvailable: 'The number of Robux is not available for purchase',
      priceNotNumber: 'The price must be a number',
      robuxMinimum: 'Cannot order less than {robux} Robux',
      robuxMaximun: 'The maximum purchase amount is temporarily limited to 5k R$',
      halfBalance: 'Cannot order more than half of the balance: {balance} Robux',
      emptyBalance: 'Robux are out of stock, please wait for replenishment',
      robuxMustDivide:
        'R$ must be divisible by {orders}. Try <span class="min">{closestMin}R$</span> or <span class="max">{closestMax}R$</span>',
      emptyCharacters: 'Enter your characters nickname and select it from the list'
    },
    selectYourPlace: 'Select your',
    timeIncreased: 'Delivery time increased.',
    setNumberRobux: 'Set the amount of robux',
    chooseNumberRobux: 'Choose the amount of robux'
  },
  gift: {
    title: 'Gift Card Purchase',
    titleMobile: 'Purchase gift',
    name: 'Gift-card',
    titleSmall: 'Gift Cards',
    badge: 'Instant Delivery!',
    infoText:
      'All disputes regarding the use of gift codes are reviewed by support only if an unedited video recording ' +
      'is provided, starting from the moment of purchasing the gift code to the moment of its verification ' +
      'on the Roblox website.',
    balanceError: 'Insufficient funds on the balance',
    errors: {
      empty: 'Select a gift card'
    }
  },
  packs: {
    title: 'Buy a robux pack',
    titleMobile: 'Buy a robux pack',
    titleSmall: 'Robux Packs',
    course: 'Great rate',
    badge: 'Fast delivery!',
    robuxCards: 'Robux Packs',
    premiumSubscription: 'Premium subscription',
    noProducts: 'Packs are temporarily unavailable, please wait for restock',
    payFromBalance: 'Pay from balance',
    cost: 'Order cost',
    balanceHint: 'Balance: {balance}',
    infoText:
      'All disputes regarding robux delivery are reviewed by support only if an unedited video recording is provided, ' +
      'from the moment of order payment to the moment of balance verification on the Roblox website.',
    benefits: {
      1: 'Instant robux',
      2: 'Safe and secure'
    },
    consent: {
      label: 'I agree to share my account details for a successful delivery',
      hint:
        'We use your account details (password and backup code) only to fulfil the order. ' +
        'We do not store them and we process them with protected methods, because we care about your security.'
    },
    errors: {
      selectPack: 'Select a robux pack',
      consent: 'Please confirm that you agree to share your account details',
      auth: 'Authorization error, please sign in again',
      product: 'Failed to get the product, try choosing another pack',
      amount: 'This robux amount is not available for purchase',
      balance: 'Insufficient funds on the balance',
      updateForbidden: 'This order can no longer be changed, please contact support'
    },
    wizard: {
      title: 'Order fulfilment',
      subtitlePrefix: 'To receive your order of',
      subtitleSuffix: 'you need to complete a few simple steps:',
      amount: '{count} robux',
      securityText:
        'We value our reputation, never store passwords anywhere and guarantee 100% safety of your account.',
      step1Title: 'Enter your Roblox password',
      step1Button: 'Done',
      passwordPlaceholder: 'Password',
      step2Title: 'Link an email address',
      step2Text: 'To send backup codes you need to link an email address. See the instructions on how to do it.',
      step2Link: 'Go to Roblox',
      step2Button: 'I linked the email',
      step3Title: 'Enter backup codes',
      step3Text:
        'Enable two-step verification via email and generate backup codes. We need them to deliver your order.',
      step3Link: 'Go to Roblox →',
      code1Placeholder: 'Backup code 1',
      code2Placeholder: 'Backup code 2',
      codeError: 'The code must be 9 characters long',
      step3Button: 'Send codes',
      videoBtn: 'Video guide',
      helpBtn: 'Help',
      usernameCopied: 'Nickname copied'
    },
    videoModal: {
      title: 'Video guide',
      placeholder: 'Video guide will be added soon',
      timecodes: {
        security: 'Security',
        email: 'Email binding',
        codes: 'Backup codes'
      }
    },
    verification: {
      title: 'Order fulfilment',
      description:
        'So that we can complete your order, follow the link and select the games you have played on the account',
      waiting: 'Once you have selected the games, come back to this page — we will continue processing automatically.',
      button: 'Go to game selection',
      helpBtn: 'Help'
    },
    processing: {
      title: 'Processing order',
      text: 'Your order will be completed soon!',
      note: 'For security reasons, <b>do not change the password or log out</b> until robux delivery is complete.',
      track: 'You can track robux delivery {here}'
    },
    history: {
      empty: 'You have no robux pack orders yet',
      actionRequired: 'Action required',
      waitingPayment: 'Awaiting payment',
      verification: 'Select games'
    }
  },
  superPass: {
    title: 'Super Pass',
    games: {
      title: 'Choose a game',
      subTitle: 'Can’t find the game you need? Contact',
      support: ' support',
      placeholder: 'Enter the name of the game to search for',
      neededGame: 'To receive a pass for the selected game, you will need to log in to the game after payment.',
      withoutGame: 'You will not need to log into the game to receive a pass.'
    },
    pass: {
      title: 'Choose a pass'
    },
    purchase: {
      title: 'Purchase super pass',
      subTitle: 'Please double-check your details before payment'
    },
    empty: {
      game: 'Couldn’t find such a game in our list',
      gameLink: 'To have us add a new game to the list, \n' + 'send our support the link to it!',
      passSearch: 'Couldn’t find such a pass in our list',
      pass: 'Passes for this game have not been added yet. \n' + 'We are already working on adding them!\n'
    },
    timer: {
      title: 'Almost Ready!',
      subTitle: 'To receive your order, you will need to log into the game! Please follow the instructions:',
      left: 'Time left',
      warningText: 'Please hurry, our specialist can only wait for you for a limited time!',
      step: {
        first: {
          title: 'Wait for your turn'
        },
        second: {
          title: 'Join the game and receive the pass',
          user: 'The user who will gift the selected pass:',
          action: 'Go to the account page and click the button',
          redirectToAccount: 'Go to the account page'
        }
      },
      statuses: {
        ready: 'Ready',
        waiting: 'Our specialist is waiting for you in the game',
        freeSoon: 'Our specialist will be free soon',
        startingOrder: 'Our specialist is starting your order',
        launchingGame: 'Our specialist is launching the game',
        preparingPass: 'Our specialist is preparing the pass',
        timeIncreased: 'Due to the high load, the order delivery time has been extended'
      }
    },
    timeInfo: {
      title: 'Purchase Super Pass',
      description:
        'This method works from <strong>10:00 AM to 12:00 AM</strong> Moscow time. ' +
        'Please try again in the morning.',
      anotherMethod: 'Buy Robux another way'
    },
    stockInfo: {
      title: 'Please try again later',
      description:
        'Unfortunately, we are unable to process your order at this time. Please try again in <strong>10 minutes</strong>',
      ok: 'Okay'
    },
    errors: {
      emptyGame: 'Select a game',
      emptyPass: 'Select a pass'
    }
  },
  logpass: {
    enterNickname: 'ENTER A NICKNAME',
    buyRobuxTitle: 'BUYING robux',
    codes: {
      code_request: 'Please enter the code that came to your email',
      order_awaiting: 'Wait for the order to be completed',
      code_request_awaiting: 'Expect a code request from the mail',

      password_error: 'Invalid password in ROBLOX',
      code_error: 'Invalid two-step authentication code from mail',
      cookie_error: 'Error. Invalid authorization data',
      email_timeout_error:
        "You didn't specify the code! Repeat the order and try to enter the code as soon as possible!",
      error: 'Error. Try again',
      success: 'Order completed successfully',
      waiting: 'Wait for the order to be completed'
    }
  },
  premium: {
    buyPremium: 'PREMIUM PURCHASE',
    alreadyExist: 'You already have Roblox Premium!',
    subscribe: {
      title: '{percent} TO THE ROBUX!',
      subtitle: 'with a Premium subscription you will get more robux '
    },
    getRbx: 'Get {rbx} to the account',
    buyWithProfit: 'BUY WITH PROFIT!',
    currencyPerMonth: '{currency} for a month',
    toPay: 'Total to be paid: ',
    premiumTime: 'Premium subscription is purchased only for {time}',
    oneMonth: '1 months without auto-renewal',
    enterPromocode: 'Enter a promo code',
    ordering: 'MAKING AN ORDER',
    mailCode: 'EXPECT A CODE REQUEST FROM THE MAIL',

    correctSum: 'Enter the correct amount',
    minRefillSum: 'The deposit amount must be at least 5 rubles'
  },
  fastpass: {
    characters: {
      inventory: 'Your inventory must be opened in your privacy settings!'
    },
    instruction: {
      plugin: 'PLUGIN',
      mobileError: 'We apologize, but it is not possible to create a plugin from a phone.\n\nPlease use a computer.',
      checkPlugin: 'Check the correctness of the data in the PLUGIN!',
      create: 'CREATION',
      edit: 'SETTINGS',
      select: 'SELECT',
      createSubtitle: 'Look at the instructions and follow all the steps indicated. Specify the price',
      editSubtitle: 'Configure your plugin. Specify the price',
      selectSubtitle: 'Select the plugin you want to use',
      actions: {
        create: 'CREATE PLUGIN',
        edit: 'CONFIGURE PLUGIN'
      }
    }
  },
  supportChat: {
    hint: 'Do you have a question?',
    title: 'PLAYER SUPPORT',
    operator: 'Your assistant',
    actions: 'Options for action',
    anket:
      'Introduce yourself to contact the operator. You will definitely get answers to questions related to RobuxPier.',
    name: 'Name',
    email: 'E-mail',
    vk: 'Link to Vkontakte',
    send: 'Send',
    enterMessage: 'Enter a message...'
  },
  qiwi: {
    details: 'REPLENISHMENT DETAILS',
    passport: 'Do you have a Russian Passport?',
    noPassport:
      'Since you do not have a Passport of the Russian Federation, you will not be able to pass verification in the Qiwi payment system.',
    hasPassport: 'You need to pass verification on the Qiwi website so that the commission is less.',
    noPassportCommission: 'The commission will be 7.5%',
    hasPassportCommission: 'The commission will be 3%',
    yes: 'Да',
    no: 'No'
  },
  history: {
    nickname: 'Game nickname',
    sumRobux: 'Amount, R$',
    sumRub: 'amount',
    status: 'Status',
    description: 'Description',
    timer: 'Timer',
    time: 'Time',
    game: 'Game',
    pass: 'Pass',
    passClick: 'Click',
    method: 'Method',

    error: 'Error',
    wait: 'Waiting',
    success: 'Successful',
    orderCount: 'Showing {order} of {length} records',
    pendingInfo: 'Track the receipt of robux',
    giftInfo: 'Code issued'
  },
  modals: {
    feedback: {
      title: 'Do you like our website?',
      text:
        'Please write a good review about our website! It will help to please you with low prices and reliable delivery!',
      submit: 'Write a review'
    },
    reviewYandex: {
      title: 'Leave a review on Yandex',
      text:
        'Did you like our website? Please leave a review on our site card — it helps other buyers and us.',
      submit: 'Write a review'
    },
    social: {
      title: 'What do we have here?',
      text: 'Promo codes, sweepstakes, memes and news are the reasons to subscribe to our social networks.'
    },
    partnership: {
      title: 'Partnership',
      text:
        'If you are a blogger and collect consistently from 3000 views, write a telegram to our manager in <span class="active">Telegram</span>',
      submit: '@Arina89731'
    },
    promocode: {
      title: 'Where can I get a promo code?',
      text: 'Subscribe to our social networks, we regularly publish profitable promo codes there!'
    },
    gift: {
      title: 'Your Gift Card Code',
      text: 'Copy the gift code and enter it in the Roblox site. You can reopen the code in the payment history.',
      submit: 'GO TO THE ROBLOX WEBSITE'
    },
    place: {
      title: "DON'T HAVE THE RIGHT PLACE?",
      text:
        'To select the place you need, you must confirm that it does not contain any prohibited content. This is a new requirement from Roblox. You will not need to complete the survey again when making future purchases with your chosen place.',
      textMob:
        'To select a place, you must confirm that it does not contain any prohibited content (a new requirement from Roblox). This must be done only during the first purchase.',
      submit: 'GO TO THE ROBLOX WEBSITE',
      subText: 'Please read the instructions below and take the Roblox survey.',
      subTextMob: 'Please complete the Roblox survey using the instructions below\n.',
      continue: 'Next',
      help: 'help',
      notification:
        'Make sure that you have completed the survey completely and that the place you want has been set to "Public" ("Public"). If you are sure, then start the purchase again.',
      notificationMob:
        'Make sure that you have completed the survey completely and that the place you want has been set to "Public" ("Public").'
    }
  },
  notFound: {
    title: 'Page Not Found',
    description: 'Try reloading the page, or return to the homepage of the website.',
    button: 'Return to Homepage'
  },
  serviceUnavailable: {
    title: 'Service Unavailable',
    description: 'Maintenance is currently underway. We apologize for the inconvenience.',
    button: 'Refresh Page'
  },
  policy,
  terms
}
